/** Pure cart lifecycle classification shared by runtime and contract smoke. */

export const SPORTS_BET_CART_TERMINAL_IDENTITY_REASON = 'SELECTION_IDENTITY_CHANGED';
export const SPORTS_BET_CART_TERMINAL_MODE_REASON = 'SELECTION_MODE_MISMATCH';

const TERMINAL_SELECTION_REASONS = new Set([
  SPORTS_BET_CART_TERMINAL_IDENTITY_REASON,
  SPORTS_BET_CART_TERMINAL_MODE_REASON,
]);

export const sportsBetCartTerminalSelectionReason = (reason) => {
  const normalized = String(reason ?? '').trim().toUpperCase();
  return TERMINAL_SELECTION_REASONS.has(normalized) ? normalized : null;
};

export const isSportsBetCartTerminalSelectionMismatch = reason => (
  sportsBetCartTerminalSelectionReason(reason) != null
);

export function resolveSportsBetCartSelectionStatus({
  currentStatus = 'active',
  currentReason = null,
  pendingOdds,
  patch = {},
  priceChanged = false,
} = {}) {
  if (isSportsBetCartTerminalSelectionMismatch(currentReason)) return 'unavailable';

  const isUnavailable = patch.unavailable === true;
  const isLocked = patch.bettable === false
    || patch.locked === true
    || patch.is_suspended === true;

  if (isUnavailable) return 'unavailable';
  if (isLocked) return 'locked';
  // A price-only update is not lifecycle authority.  In particular, an odds
  // tick must never reopen a selection that was already locked/unavailable;
  // only an explicit bettable=true patch may move it back toward acceptance.
  if (priceChanged) {
    if (['locked', 'unavailable'].includes(currentStatus) && patch.bettable !== true) {
      return currentStatus;
    }
    return 'odds_changed';
  }
  if (['locked', 'unavailable'].includes(currentStatus) && patch.bettable === true) {
    return pendingOdds != null ? 'odds_changed' : 'active';
  }
  return currentStatus;
}

export default Object.freeze({
  isSportsBetCartTerminalSelectionMismatch,
  resolveSportsBetCartSelectionStatus,
  sportsBetCartTerminalSelectionReason,
});
